import React from 'react';

import InputField from '../../../components/inputs/inputField';
import FieldModal from '../../../components/modals/fieldModal';
import ToggleField from '../../../components/inputs/toggleField';

const durationUnits = [{ value: 'minutes', label: 'Minutes' }, { value: 'hours', label: 'Hours' }];
const dateRangeTypes = [
	{ value: 'fixed', label: 'Days into the future' },
	{ value: 'dateRange', label: 'Within Date Range' },
	{ value: 'indefinite', label: 'Indefinitely into the future' }
];

class AddCalendarModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			calendarName: '',
			location: '',
			startDate: '',
			endDate: '',
			submitting: false,
			invalid: false,
			requiredFields: {
				name: false,
				location: false,
				startDate: false,
				endDate: false
			},
            limitSpots: false,
            maxSpots: '',
		};
	}

	handleCalendarNameChange = (val) => {
		this.setState({
			calendarName: val.target.value
		});
	};
    
	handleLocationChange = (val) => {
		this.setState({
			location: val.target.value,
		});
	}

	handleStartDateChange = (val) => {
		this.setState({
			startDate: val.target.value,
		});
	}

	handleEndDateChange = (val) => {
		this.setState({
			endDate: val.target.value,
		});
	}
    
    handleLimitSpots = (val) => {
        this.setState({
            limitSpots: val.target.checked
        });
	};
	handleMaxSpots = (e) => {
		const value = e.target.value;
		if (value === '' || Number(value) >= 0) {
			this.setState({ maxSpots: value });
		}
	};
	addCalendar = async () => {
		const calendar = {
			name: this.state.calendarName,
			location: this.state.location,
			startDate: this.state.startDate,
			endDate: this.state.endDate,
            limitSpots: this.state.limitSpots,
            maxSpots: this.state.maxSpots
		};
		const requiredFields = this.state.requiredFields;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!calendar[key] || calendar[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});
		if (this.state.limitSpots && (!this.state.maxSpots || this.state.maxSpots === '')) {
			valid = false;
		}
		
		if (valid) {
			this.setState({ invalid: false, submitting: true });
			await this.props.addCalendar(calendar, this.props.toggle);
		} else {
			this.setState({ invalid: true, requiredFields: requiredFields });
		}
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { calendarName, location, startDate, endDate, invalid, requiredFields, submitting } = this.state;
		return (

			<FieldModal
				size="medium"
				isOpen={isOpen}
				modalTitle={"Add New Calendar"}
				bodyHeaderText={''}
				bodyDescription={''}
				bodyContent={() => {
					return (
						<div className='sectionContainer'>
							<div className='sectionBody'>
								<InputField
									label="Calendar Name"
									value={calendarName}
									onChange={this.handleCalendarNameChange}
									required={true}
									errorTrigger={requiredFields.name}
									invalid={invalid}
								/>
								<InputField
									label="Location"
									value={location}
									onChange={this.handleLocationChange}
									required={true}
									errorTrigger={requiredFields.location}
									invalid={invalid}
									placeholder="Enter location of meeting, virtual or physical"
								/>
								<div className="flex gap20">
									<InputField
										label="Start Date"
										type="date"
										value={startDate}
										onChange={this.handleStartDateChange}
										required={true}
										errorTrigger={requiredFields.startDate}
										invalid={invalid}
										inputIcon={<i className="las la-calendar" />}
									/>
									<InputField
										label="End Date"
										type="date"
										value={endDate}
										onChange={this.handleEndDateChange}
										required={true}
										errorTrigger={requiredFields.endDate}
										invalid={invalid}
										min={startDate}
										inputIcon={<i className="las la-calendar" />}
									/>
								</div>
                                <ToggleField
                                    label="Limit Spots"
                                    checked={this.state.limitSpots}
                                    onChange={this.handleLimitSpots}
                                    icons={false}
                                />
                                {this.state.limitSpots && (
                                    <InputField
                                        label="Max Spots"
                                        value={this.state.maxSpots}
                                        onChange={this.handleMaxSpots}
                                        type="number"
										min={1}
                                        required={true}
                                        errorTrigger={!this.state.maxSpots || this.state.maxSpots <= 0}
                                        invalid={invalid}
                                    />
                                )}
							</div>
						</div>)
				}}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Add' : 'Adding...'}
				actionButton={() => this.addCalendar()}
				actionButtonDisabled={submitting}
			></FieldModal>

		);
	}
}

export default AddCalendarModal;
